var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('div',{staticClass:"news"},[_vm._l((_vm.articles),function(article,index){return _c('NewsCard',{key:article._id,attrs:{"article":article,"index":index}})}),_c('div',{staticStyle:{"margin-bottom":"60px"}})],2)])}
var staticRenderFns = []

export { render, staticRenderFns }